class ContextMethodNotFound extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ContextMethodNotFound';
  }
}

export default ContextMethodNotFound;
